<template>
    <div class="container-fluid" style="width: 1020px;">
        <!--Heading-->
        <div class="row">
            <div class="col-lg-8 m-b-10">
                <h2 class="m-b-0 font-medium">PO # {{po.number}}</h2>
            </div>
            <div class="col-lg-4 text-right">
                <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true"
                            class="btn waves-effect waves-light btn-outline-success dropdown-toggle"
                            data-toggle="dropdown" type="button">
                        Action
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" data-target="#attachmentModal" data-toggle="modal"
                           href="javascript:void(0)">Upload Attachment</a>
                        <a class="dropdown-item" data-target="#storedAttachmentModal" data-toggle="modal"
                           href="javascript:void(0)">View Attachment</a>
                        <a @click="confirm" class="dropdown-item" href="javascript:void(0)"
                           v-if="po.status === 'DRAFT'">Confirm</a>
                        <a class="dropdown-item" data-target="#myModal"
                           data-toggle="modal" href="javascript:void(0)"
                           v-if="po.status === 'CONFIRMED'">Receive</a>
                        <a @click="_void" class="dropdown-item"
                           href="javascript:void(0)" v-if="po.status === 'CONFIRMED' || po.status === 'DRAFT'">Void</a>
                        <div class="dropdown-divider"></div>
                        <a @click="printPurchase()" class="dropdown-item" href="javascript:void(0)">Print</a>
                    </div>
                </div>
            </div>
        </div>

        <!--Quick Summary-->
        <div class="row m-t-15">
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3>
                            <span class="label label-megna" v-if="po.status === 'DRAFT'">Draft</span>
                            <span class="label label-light-green" v-if="po.status === 'CONFIRMED'">Confirmed</span>
                            <span class="label label-dark-green" v-if="po.status === 'RECEIVED'">Received</span>
                            <span class="label label-grey" v-if="po.status === 'VOID'">Void</span>
                        </h3>
                        <span>Status</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0">{{po.seller.biz_name}}</h3>
                        <span>Supplier</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 :class="{'text-danger': po.status !== 'RECEIVED'}" class="font-medium m-b-0">{{ { amount :
                            po.total, ...po.currency } | money }}</h3>
                        <span v-if="po.status === 'RECEIVED'">Amount Paid</span>
                        <span v-else>Amount Due</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 text-right">
                <div class="ml-auto">
                    <div>
                        <h3 class="font-medium text-right m-b-0">{{po.created_at || "—" | medium}}</h3>
                        <span class="text-right">Creation Date</span>
                    </div>
                </div>
            </div>
        </div>

        <!--Purchase Order -->
        <div class="row ">
            <div class="col-md-12" id="printMe">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center m-b-0">
                            <div>
                                <h3 class="font-medium">
                                    <span class="text-muted">PO # </span> {{po.number}}
                                </h3>
                                <h3>
                                    <span class="label label-dark-green">(Paid)</span>
<!--                                    <span class="label label-light-green" v-if="po.status === 'CONFIRMED'">Confirmed</span>-->
<!--                                    <span class="label label-dark-green" v-if="po.status === 'RECEIVED'">Received</span>-->
<!--                                    <span class="label label-grey" v-if="po.status === 'VOID'">Void</span>-->
                                </h3>
<!--                                <h5 class="font-medium" v-if="po.contract_number">-->
<!--                                    <span class="text-muted">Contract # </span> {{po.contract_number}}-->
<!--                                </h5>-->
<!--                                <h5 class="font-medium" v-else>-->
<!--                                    <span class="text-muted">Contract # </span> N/A-->
<!--                                </h5>-->
                            </div>
                            <div class="ml-auto">
                                <div>
                                    <h6>PO Issue Date: <span class="font-weight-normal">{{po.created_at | date}}</span></h6>
                                    <h6>Delivery Date: <span class="font-weight-normal">December 3rd 2020</span></h6>
                                    <h6>Payment Date: <span class="font-weight-normal">December 3rd 2020</span></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="m-0">
                    <div class="card card-body printableArea">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="pull-left">
                                    <address>
                                        <h3><b class="text-danger">{{po.buyer.biz_name}}</b></h3>
<!--                                        <h6 class="font-weight-normal" v-html="po.buyer.description">-->
<!--                                            {{po.buyer.description}}</h6>-->
                                        <p class="text-muted m-b-5">
                                            <i class="fas fa-phone"></i>&nbsp;{{po.buyer.biz_phone}}<br/>
                                            <i class="fas fa-envelope"></i>&nbsp;{{po.buyer.biz_email}}
                                        </p>
                                        <p class="text-muted">
                                            {{po.buyer.line1}}&nbsp;{{po.buyer.line2}},
                                            <br/>{{po.buyer.country}},&nbsp;{{po.buyer.city}},
                                            <br/>{{po.buyer.state}},&nbsp;{{po.buyer.postal_code}}
                                        </p>
                                    </address>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="pull-right">
                                    <dl class="row mb-0">
                                        <div class="col-sm-8 offset-4 text-sm-left">
                                            <dt>Issued To:</dt>
                                            <dd class="mb-1">
                                                <h4 class="font-bold">{{po.seller.biz_name}}</h4>
<!--                                                <h6 class="font-weight-normal">-->
<!--                                                    Audit: <a :href="po.audit" v-if="po.audit">{{po.audit}}</a>-->
<!--                                                    <span v-else>N/A</span>-->
<!--                                                </h6>-->
                                                <address>
                                                    <p class="text-muted">
                                                        <i class="fas fa-phone"></i>&nbsp;{{po.seller.biz_phone}}<br/>
                                                        <i class="fas fa-envelope"></i>&nbsp;{{po.seller.biz_email}}
                                                    </p>
                                                </address>
                                                <address>
                                                    <p class="text-muted">{{po.seller.line1}}&nbsp;{{po.seller.line2}},
                                                        <br/>{{po.seller.country}},&nbsp;{{po.seller.city}},
                                                        <br/>{{po.seller.state}},&nbsp;{{po.seller.postal_code}}</p>
                                                </address>
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-30">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-hover table-bordered">
                                        <thead>
                                        <th class="font-weight-bold">Item</th>
                                        <th class="text-right font-weight-bold">Quantity</th>
                                        <th class="text-right font-weight-bold">Unit Cost</th>
                                        <th class="text-right font-weight-bold">Tax</th>
                                        <th class="text-right font-weight-bold">Total</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="good in po.goods">
                                            <td>{{good.name}} - {{good.variety}}</td>
                                            <td class="text-right">{{good.quantity | unitFix(2)}} {{good.unit.symbol}}
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{good.rate | unitFix(2)
                                                }}/{{good.unit.symbol}}
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{ (good.rate *
                                                good.quantity)*(good.tax/100) | unitFix(2) }} ({{good.tax |
                                                unitFix(2)}}%)
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{good.rate * good.quantity | unitFix(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{po.tax_total | unitFix(2) }}
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{po.item_total | unitFix(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Item Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.currency.currency_symbol}} {{po.item_total + po.tax_total |
                                                unitFix(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Discount
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.currency.currency_symbol}} {{po.discount | unitFix(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.currency.currency_symbol}} {{po.item_total + po.tax_total -
                                                po.discount | unitFix(2) }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr>
                                <div class="pull-right m-t-30 text-right">
                                    <h3>Total: {{po.currency.currency_symbol}} {{po.total | unitFix(2) }}</h3>
                                    <h5 class="font-weight-normal">{{po.currency.currency_symbol}} {{ po.total |
                                        unitFix(2) | words }} </h5>
                                </div>
                                <hr>
                                <div class="">
                                    <b>Remarks :</b>
                                    <p>{{po.comments || 'N/A'}}</p>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row m-t-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center m-b-0">
                            <div>
                                <h3 class="font-medium">
                                    <span class="text-muted">PO # </span> {{po.number}}
                                </h3>
                                <h5 class="font-medium" v-if="po.contract_number">
                                    <span class="text-muted">Contract # </span>
                                    <router-link :to="{name: 'viewcontract', params : { contractid: po.contract_id }}"
                                                 v-if="po.contract_id">{{po.contract_number}}
                                    </router-link>
                                    <span v-else>{{po.contract_number}}</span>
                                </h5>
                                <h5 class="font-medium" v-else>
                                    <span class="text-muted">Contract # </span> N/A
                                </h5>
                            </div>
                            <div class="ml-auto">
                                <div>
                                    <h6>PO Date: <span class="font-weight-normal">{{po.created_at | date}}</span></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="m-0">
                    <div class="card card-body printableArea">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="pull-left">
                                    <address>
                                        <h3><b class="text-danger">{{po.buyer.biz_name}}</b></h3>
                                        <h6 class="font-weight-normal" v-html="po.buyer.description">
                                            {{po.buyer.description}}</h6>
                                        <p class="text-muted m-b-5">
                                            <i class="fas fa-phone"></i>&nbsp;{{po.buyer.biz_phone}}<br/>
                                            <i class="fas fa-envelope"></i>&nbsp;{{po.buyer.biz_email}}
                                        </p>
                                        <p class="text-muted">
                                            {{po.buyer.line1}}&nbsp;{{po.buyer.line2}},
                                            <br/>{{po.buyer.country}},&nbsp;{{po.buyer.city}},
                                            <br/>{{po.buyer.state}},&nbsp;{{po.buyer.postal_code}}
                                        </p>
                                    </address>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="pull-right">
                                    <dl class="row mb-0">
                                        <div class="col-sm-8 offset-4 text-sm-left">
                                            <dt>Issued To:</dt>
                                            <dd class="mb-1">
                                                <h4 class="font-bold">{{po.seller.biz_name}}</h4>
                                                <h6 class="font-weight-normal">
                                                    Audit: <a :href="po.audit" v-if="po.audit">{{po.audit}}</a>
                                                    <span v-else>N/A</span>
                                                </h6>
                                                <address>
                                                    <p class="text-muted">
                                                        <i class="fas fa-phone"></i>&nbsp;{{po.seller.biz_phone}}<br/>
                                                        <i class="fas fa-envelope"></i>&nbsp;{{po.seller.biz_email}}
                                                    </p>
                                                </address>
                                                <address>
                                                    <p class="text-muted">{{po.seller.line1}}&nbsp;{{po.seller.line2}},
                                                        <br/>{{po.seller.country}},&nbsp;{{po.seller.city}},
                                                        <br/>{{po.seller.state}},&nbsp;{{po.seller.postal_code}}</p>
                                                </address>
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-30">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-hover table-bordered">
                                        <thead>
                                        <th class="font-weight-bold">Item</th>
                                        <th class="text-right font-weight-bold">Quantity</th>
                                        <th class="text-right font-weight-bold">Unit Cost</th>
                                        <th class="text-right font-weight-bold">Tax</th>
                                        <th class="text-right font-weight-bold">Total</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="good in po.goods">
                                            <td>{{good.name}} - {{good.variety}}</td>
                                            <td class="text-right">{{good.quantity | unitFix(2)}} {{good.unit.symbol}}
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{good.rate | unitFix(2)
                                                }}/{{good.unit.symbol}}
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{ (good.rate *
                                                good.quantity)*(good.tax/100) | unitFix(2) }} ({{good.tax |
                                                unitFix(2)}}%)
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{good.rate * good.quantity | unitFix(2)
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{po.tax_total | unitFix(2) }}
                                            </td>
                                            <td class="text-right">
                                                {{po.currency.currency_symbol}} {{po.item_total | unitFix(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Item Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.currency.currency_symbol}} {{po.item_total + po.tax_total |
                                                unitFix(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Discount
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.currency.currency_symbol}} {{po.discount | unitFix(2) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.currency.currency_symbol}} {{po.item_total + po.tax_total -
                                                po.discount | unitFix(2) }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr>
                                <div class="pull-right m-t-30 text-right">
                                    <h3>Total: {{po.currency.currency_symbol}} {{po.total | unitFix(2) }}</h3>
                                    <h5 class="font-weight-normal">{{po.currency.currency_symbol}} {{ po.total |
                                        unitFix(2) | words }} </h5>
                                </div>
                                <hr>
                                <div class="">
                                    <b>Remarks :</b>
                                    <p>{{po.comments || 'N/A'}}</p>
                                </div>
                                <hr v-if="['DRAFT','CONFIRMED'].includes(po.status)">
                                <button @click="_void"
                                        class="btn btn-outline-danger waves-effect waves-light ml-2 float-right"
                                        type="button" v-if="po.status === 'DRAFT' || po.status === 'CONFIRMED'">
                                    Void
                                </button>
                                <button class="btn btn-outline-success waves-effect waves-light ml-2 float-right"
                                        data-target="#myModal"
                                        data-toggle="modal" type="button"
                                        v-if="po.status === 'CONFIRMED'">
                                    Receive
                                </button>
                                <button @click="confirm"
                                        class="btn btn-outline-primary waves-effect waves-light ml-2 float-right"
                                        type="button"
                                        v-if="po.status === 'DRAFT'">
                                    Confirm
                                </button>
                                <router-link :to="{ name: 'editexpresspurchase',  paramas: { poid: poid}}"
                                             class="btn btn-outline-info waves-effect waves-light ml-2 float-right"
                                             v-if="['DRAFT','CONFIRMED'].includes(po.status)">
                                    Edit
                                </router-link>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modals -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="storedAttachmentModal"
             role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h4 class="modal-title" id="storedAttachmentModalLabel">Stored Attachments</h4>
                            <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card-body">
                                <h5 class="text-teal text-center" v-if="storedAttachment.length ===0">No Attachment
                                    found</h5>
                                <div class="table-responsive" v-if="storedAttachment.length >0">
                                    <table class="table no-wrap v-middle">
                                        <thead>
                                        <tr class="bg-light">
                                            <th class="border-0"><h6>File Name</h6></th>
                                            <th class="border-0"><h6>Title</h6></th>
                                            <th class="border-0"><h6>Description</h6></th>
                                            <th class="border-0"><h6>Action</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(a, index) in storedAttachment">
                                            <td>{{a.filename}}</td>
                                            <td>{{a.title}}</td>
                                            <td>{{a.desc}}</td>
                                            <td>
                                                <a @click="downloadFile(a.filename)"
                                                   class="text-info"
                                                   href="javasript:void(0);">
                                                    <b>Download</b>
                                                </a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal"
                                    type="button">Close
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="attachmentModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h4 class="modal-title" id="attachmentModalLabel">Upload Attachments</h4>
                            <button @click="closeAttachmentModal()" aria-hidden="true" class="close"
                                    data-dismiss="modal" type="button">×
                            </button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card-body">
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <input
                                                class="form-control"
                                                name="file_title"
                                                placeholder="Title"
                                                style="height: 42px;"
                                                type="text"
                                                v-model="fileTitle">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <textarea
                                                class="form-control"
                                                data-vv-as="description"
                                                id="description"
                                                name="description"
                                                placeholder="File Description"
                                                rows=3
                                                v-model="fileDesc">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="input-group col-md-8">
                                        <div class="custom-file">
                                            <input @change="onFileChange"
                                                   class="custom-file-input"
                                                   id="inputGroupFile01"
                                                   ref="file"
                                                   type="file">
                                            <label class="custom-file-label" for="inputGroupFile01"
                                                   style="cursor: pointer">{{filename}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive p-t-25" v-if="attachments.length >0">
                                    <table class="table no-wrap v-middle">
                                        <thead>
                                        <tr class="bg-light">
                                            <th><h6>File Name</h6></th>
                                            <th><h6>Title</h6></th>
                                            <th><h6>Description</h6></th>
                                            <th><h6>Action</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(a, index) in attachments">
                                            <td>{{a.filename}}</td>
                                            <td>{{a.title}}</td>
                                            <td>{{a.desc}}</td>
                                            <td>
                                                <a @click="deleteFile(a.id, a.filepath)"
                                                   class="text-danger"
                                                   href="javasript:void(0);">
                                                    <b>Remove</b>
                                                </a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="saveAttachment()" class="btn btn-success" data-dismiss="modal"
                                    type="button">Submit
                            </button>
                            <button @click="closeAttachmentModal()" class="btn waves-effect waves-light btn-danger"
                                    data-dismiss="modal"
                                    type="button">Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modals end -->

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="myModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form @submit.prevent="handleSubmit" data-vv-scope="receive-commodity-form">
                        <div class="modal-header">
                            <h4 class="modal-title" id="myModalLabel">Receive commodities</h4>
                            <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                        </div>
                        <div class="modal-body">
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-sm-2 control-label col-form-label" for="warehouse">Warehouse</label>
                                    <div class="col-sm-10">
                                        <div :class="{'is-invalid': submitted && errors.has('warehouse')}"
                                             class="form-control p-0-0">
                                            <multiselect
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :hide-selected="true"
                                                    :internal-search="false"
                                                    :limit="3"
                                                    :loading="isLoading"
                                                    :max-height="600"
                                                    :options="warehouses"
                                                    :options-limit="300"
                                                    :searchable="true"
                                                    :show-no-results="false"
                                                    @search-change="getWareHouses"
                                                    data-vv-as="warehouse"
                                                    id="warehouse"
                                                    label="warehouse"
                                                    name="warehouse"
                                                    open-direction="bottom"
                                                    placeholder="Search warehouse"
                                                    track-by="id"
                                                    v-model="warehouse"
                                                    v-validate="'required'">
                                                <template slot="singleLabel" slot-scope="props">
                                                    {{props.option.name}}
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div class="option__desc">
                                                        <h5>{{ props.option.name }}</h5>
                                                        <h6>{{ props.option.line1 +', '+ props.option.city+', '+
                                                            props.option.country}}</h6>
                                                    </div>
                                                </template>
                                                <span slot="noResult">Warehouse not found</span>
                                            </multiselect>
                                        </div>
                                        <div class="invalid-feedback" v-if="submitted && errors.has('warehouse')">{{
                                            errors.first('warehouse') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title">Commodities</h5>
                                <p class="card-subtitle">Purchase order items that will be moved into the above-selected warehouse.</p>
                                <div class="mt-3 table-responsive" style="clear: both;">
                                    <table class="table table-hover table-bordered">
                                        <thead>
                                        <th class="font-weight-bold">Commodity</th>
                                        <th class="text-right font-weight-bold">Quantity</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="good in po.goods">
                                            <td>{{good.name}}</td>
                                            <td class="text-right">{{good.quantity | unitFix(2)}} {{good.unit.symbol}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn waves-effect waves-light btn-success" type="submit">Submit</button>
                            <button @click="reset" class="btn waves-effect waves-light btn-secondary" type="button">
                                Reset
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from '../../../common/Blockie';
    import _ from "lodash";
    import axios from 'axios';
    import uuid from "uuid/v4";
    import Multiselect from 'vue-multiselect';

    export default {
        name: "ViewExpressPurchase",
        props: ["poid"],
        components: {Multiselect, Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                isLoading: false,
                po: {
                    id: null,
                    number: null,
                    status: null,
                    created_at: null,
                    express_id: 1,
                    attachments: [],
                    total: 0,
                    seller: {
                        id: null,
                        name: null,
                        biz_name: null,
                        biz_web: null,
                        biz_email: null,
                        biz_phone: null
                    },
                    buyer: {
                        id: null,
                        name: null,
                        biz_name: null,
                        biz_web: null,
                        biz_email: null,
                        biz_phone: null
                    },
                    currency: {
                        currency_id: null,
                        currency_name: null,
                        currency_symbol: null
                    },
                    goods: []
                },
                items: [],
                warehouses: [],
                warehouse: null,
                purchaseItem: null,
                quantity: null,
                activeWalletAddress: null,
                orgImg: null,
                file: File,
                filename: "Upload Attachment",
                uploadstatus: '',
                attachments: [],
                fileTitle: '',
                fileDesc: '',
                storedAttachment: []
            };
        },
        mounted() {
            this.init();
            this.$root.$on('refreshPo', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getPurchaseOrder();
                await this.getAttachment();
            },
            async getPurchaseOrder() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/purchases/${this.poid}`);
                $(".preloader").fadeOut();
                this.po = reply.data;
                this.po.item_total = _.sumBy(this.po.goods, function (o) {
                    return o.rate * o.quantity;
                });

                this.po.tax_total = _.sumBy(this.po.goods, function (o) {
                    return (o.rate * o.quantity) * (o.tax / 100);
                });

            },
            async onFileChange(e) {
                this.file = this.$refs.file.files[0];
                this.filename = this.file.name;
                await this.uploadFile();
            },
            async uploadFile() {
                this.uploadstatus = "Uploading File Please Wait";
                let signedurl = await this.getUploadUrl();
                $(".preloader").fadeIn();
                await axios.put(signedurl, this.file);
                $(".preloader").fadeOut();
                this.resetAttachment();
            },
            async getUploadUrl() {
                let signedUrl = await this.$http.get(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/signedurl`, {
                    params: {
                        name: this.filename,
                        type: 'write'
                    }
                });

                let parts = this.filename.split(".");
                this.attachments.push({
                    id: uuid(),
                    filename: this.filename,
                    title: this.fileTitle,
                    desc: this.fileDesc,
                    filepath: signedUrl.data.key,
                    contenttype: parts[parts.length - 1]
                });

                return signedUrl.data.url;
            },
            async getDownloadUrl(filename) {
                $(".preloader").fadeIn();
                let signedUrl = await this.$http.get(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/signedurl`, {
                    params: {
                        name: filename,
                        type: 'read'
                    }
                });
                $(".preloader").fadeOut();
                return signedUrl.data.url;
            },
            async saveAttachment() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/attachments`, this.attachments);
                    this.uploadstatus = "";
                    this.attachments = [];
                    this.resetAttachment();
                    await this.getAttachment();
                    this.$toastr('success', 'Attachment uploaded successfully', 'Success');
                } catch (e) {

                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getAttachment() {
                try {
                    let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/attachments`);
                    this.storedAttachment = reply.data;
                } catch (e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                }
            },
            async downloadFile(filename) {
                $(".preloader").fadeIn();
                let signedUrl = await this.getDownloadUrl(filename);
                $(".preloader").fadeOut();
                let link = document.createElement('a');
                link.download = filename;
                link.href = signedUrl;
                link.click();
            },
            async deleteFile(id, filepath) {
                $(".preloader").fadeIn();
                await this.$http.delete(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/attachments`, {
                    data: {
                        filepath: filepath
                    }
                });
                $(".preloader").fadeOut();
                _.remove(this.attachments, function (a) {
                    return a.id == id;
                });
                this.attachments = JSON.parse(JSON.stringify(this.attachments));
                this.resetAttachment();
                this.$toastr('success', 'Attachment deleted successfully', 'Success');
            },
            closeAttachmentModal() {
                this.attachments = [];
                this.resetAttachment();
            },
            resetAttachment() {
                this.file = File;
                this.filename = "Upload Attachment";
                this.fileTitle = "";
                this.fileDesc = "";
            },
            printPurchase() {
                this.$htmlToPaper('printMe');
            },
            async confirm() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/confirm`);
                    await this.getPurchaseOrder();
                } catch (e) {
                    this.$toastr('error', e.response.data.message, 'Failure');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async receive() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/receive`, {
                        items: this.po.goods,
                        warehouse_id: this.warehouse.id
                    });
                    this.$toastr('success', 'Successfully received', 'Success!');
                    await this.getPurchaseOrder();
                    this.reset();
                } catch (e) {
                    console.dir(e);
                    this.$toastr('error', e.response.data.message, 'Failure');
                } finally {
                    $('#myModal').modal('hide');
                    $(".preloader").fadeOut();
                }
            },
            async _void() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/express/${this.currentOrg.express_id}/purchases/${this.poid}/void`);
                    await this.getPurchaseOrder();
                } catch (e) {
                    this.$toastr('error', e.response.data.message, 'Failure');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async handleSubmit() {
                this.submitted = true;
                let valid = await this.$validator.validate();
                if (valid) {
                    await this.receive();
                } else {
                    this.$toastr('error', 'You have to select a warehouse!', 'Failure');
                }
            },
            async getWareHouses(searchText) {
                let response = await this.$http.get(`/express/${this.currentOrg.express_id}/inventory/warehouses`, {
                    params: {
                        search: searchText
                    }
                });

                this.warehouses = response.data.warehouses;
            },
            reset() {
                this.submitted = false;
                this.warehouse = null;
            },
        }
    }
</script>

<style scoped>

</style>
